import { InjectionToken, Provider, Type } from '@angular/core';
import {
  SharedProfileAdapter,
  SharedProfileConfig,
} from './profile.types';

export const SHARED_PROFILE_ADAPTER = new InjectionToken<SharedProfileAdapter>(
  'SHARED_PROFILE_ADAPTER',
);
export const SHARED_PROFILE_CONFIG = new InjectionToken<SharedProfileConfig>(
  'SHARED_PROFILE_CONFIG',
);

export function provideSharedProfile(
  config: SharedProfileConfig,
  adapter: Type<SharedProfileAdapter>,
): Provider[] {
  return [
    { provide: SHARED_PROFILE_CONFIG, useValue: config },
    { provide: SHARED_PROFILE_ADAPTER, useClass: adapter },
  ];
}
